import React, { FC } from 'react';

// components
import AampeDatePicker from '../../../components/inputs/datepicker/AampeDatePicker';
import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

interface FormulaDatePickerProps {
    isDisabled?: boolean;
    selectedDate: Date | null;
    setSelectedDate: (startDate: Date) => void;
    minDate: Date | null;
    maxDate: Date | null;
    isClearable?: boolean;
}

const FormulaDatePicker: FC<React.PropsWithChildren<FormulaDatePickerProps>> =
    ({
        isDisabled,
        selectedDate,
        setSelectedDate,
        isClearable,
        maxDate,
        minDate,
    }) => {
        return (
            <Container>
                <div>
                    <AampeDatePicker
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        minDate={minDate}
                        maxDate={maxDate}
                        isClearable={isClearable}
                        isDisabled={isDisabled}
                        textStyle={{ color: aampeTheme.colors.neutral09 }}
                    />
                </div>
            </Container>
        );
    };

export default FormulaDatePicker;

const Container = styled.div({
    display: 'flex',
    gap: aampeTheme.spacing(1.5),
    alignItems: 'center',
});
